// if (!customElements.get('terms-conditions')) {
//   customElements.define(
//     'terms-conditions',
//     class TermsConditions extends HTMLElement {
//       constructor() {
//         super();
//         const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
//         checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions || 0;
//         checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
//         checkoutBtn.disabled = true;

//         const termsAndConditions = document.querySelector('#terms_and_conditions');

//         termsAndConditions.addEventListener('change', (e) => {
//           if(termsAndConditions.checked === true) {
//             checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions - 1;

//             if(+checkoutBtn.dataset.awaitingCheckoutConditions === 0) {
//               checkoutBtn.disabled = false;
//             }
//           } else {
//             checkoutBtn.dataset.awaitingCheckoutConditions = +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
//             checkoutBtn.disabled = true;
//           }
//         });
//       }
//     }
//   );
// }

function updateCartCheckoutPrompt() {
  const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
  const prompt = document.getElementById('cart-checkout-prompt');
  const promptText = document.getElementById('cart-checkout-prompt-text');
  
  if (!prompt || !checkoutBtn || !promptText) return;
  
  const zapietBlocked = checkoutBtn.dataset.zapietBlocked === 'true';
  const termsCheckbox = document.getElementById('terms_and_conditions');
  const termsBlocked = termsCheckbox && !termsCheckbox.checked;
  
  // Update button state
  checkoutBtn.disabled = zapietBlocked || termsBlocked;
  
  // Update prompt message
  if (zapietBlocked && termsBlocked) {
    promptText.textContent = promptText.getAttribute('data-delivery-text') || 
      "Para proceder, seleccione 'Entrega local' o 'Tienda de recogida' arriba.";
    prompt.hidden = false;
  } else if (zapietBlocked) {
    promptText.textContent = promptText.getAttribute('data-delivery-text') || 
      "Para proceder, seleccione 'Entrega local' o 'Tienda de recogida' arriba.";
    prompt.hidden = false;
  } else if (termsBlocked) {
    promptText.textContent = promptText.getAttribute('data-terms-text') || 
      "Para proceder, acepte los términos y condiciones.";
    prompt.hidden = false;
  } else {
    prompt.hidden = true;
  }
}

if (!customElements.get('terms-conditions')) {
  customElements.define(
    'terms-conditions',
    class TermsConditions extends HTMLElement {
      constructor() {
        super();
        
        const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
        if (!checkoutBtn) return;
        
        const termsAndConditions = document.querySelector('#terms_and_conditions');
        if (!termsAndConditions) return;
        
        // Initial state
        checkoutBtn.disabled = true;
        updateCartCheckoutPrompt();

        // Listen for changes to terms checkbox
        termsAndConditions.addEventListener('change', (e) => {
          // Just update the prompt - it will check both states
          updateCartCheckoutPrompt();
        });
      }
    }
  );
}
